import React, { useState, useEffect } from 'react';
import './MatterportViewer.css';

const MatterportViewer = ({ 
  matterportId = "M2oteENHc9t",
  className = "" 
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { 
        threshold: 0.1,
        rootMargin: '100px' // Začne načítat 100px předem
      }
    );

    const element = document.querySelector('.matterport-section');
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  const handleIframeLoad = () => {
    setIsLoaded(true);
  };

  return (
    <section className={`matterport-section ${className}`}>
      <div className="matterport-content">
        <div className="matterport-header">
          <h2 className="matterport-title">Virtuální prohlídka</h2>
          <p className="matterport-subtitle">
            Projděte si naše fitness centrum z pohodlí domova a poznejte každý kout našich moderních prostor
          </p>
        </div>
        
        <div className="matterport-container">
          {!isVisible ? (
            <div 
              style={{
                width: '100%',
                height: '600px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(255, 255, 255, 0.05)',
                borderRadius: '20px',
                color: '#ffffff',
                fontSize: '18px'
              }}
            >
              <p>Načítám virtuální prohlídku...</p>
            </div>
          ) : (
            <>
              {!isLoaded && (
                <div 
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(0, 0, 0, 0.7)',
                    borderRadius: '20px',
                    zIndex: 3,
                    color: '#ffed01',
                    fontSize: '20px'
                  }}
                >
                  <div style={{ textAlign: 'center' }}>
                    <div className="loader"></div>
                    <p style={{ marginTop: '20px' }}>Načítám 3D prohlídku...</p>
                  </div>
                </div>
              )}
              <iframe
                src={`https://my.matterport.com/show/?m=${matterportId}`}
                frameBorder="0"
                allowFullScreen
                allow="autoplay; fullscreen; web-share; xr-spatial-tracking;"
                title="3D Virtual Tour - Fit Elite Česká Lípa"
                onLoad={handleIframeLoad}
                loading="lazy"
                style={{ opacity: isLoaded ? 1 : 0 }}
              />
            </>
          )}
        </div>
      </div>

      <style jsx>{`
        .loader {
          border: 4px solid rgba(255, 237, 1, 0.3);
          border-radius: 50%;
          border-top: 4px solid #ffed01;
          width: 50px;
          height: 50px;
          animation: spin 1s linear infinite;
          margin: 0 auto;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </section>
  );
};

export default MatterportViewer;